/**
 * Angular library starter
 * Build an Angular library compatible with AoT compilation & Tree shaking like an official package
 * Copyright Roberto Simonetti
 * MIT license
 * https://github.com/mediamanDE/angular-three-sixty
 */

/**
 * Entry point for all public APIs of the package.
 */
export * from './src/angular-three-sixty';

// This file only reexports content of the `src` folder. Keep it that way.
